"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-multi-comp */
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const polaris_1 = require("@shopify/polaris");
const polaris_icons_1 = require("@shopify/polaris-icons");
const OrderDetails_1 = require("components/Dashboard/OrderDetails");
const noShipments_png_1 = __importDefault(require("assets/images/dashboard/noShipments.png"));
const styles_1 = require("./ScanEventModal/styles");
const ScanEventModal_1 = require("./ScanEventModal");
const styles_2 = require("./styles");
const ScanEventInfo_1 = require("./ScanEventInfo");
// prettier-ignore
const statusMappings = {
    'available_for_pickup': 'Available for Pickup',
    'bad_tracking_code_error': 'Invalid Tracking Code',
    'cancelled': 'Cancelled',
    'delivered': 'Delivered',
    'error': 'Error',
    'failure': 'Failure to Deliver',
    'in_transit': 'In Transit',
    'out_for_delivery': 'Out for Delivery',
    'pending': 'Pending',
    'pre_transit': 'Pre-Transit',
    'return_to_sender': 'Returned to Sender',
    'unknown': 'Unknown'
};
const ShipmentDisplay = ({ shipment, order, callback }) => {
    const statusString = statusMappings[shipment.status];
    const shipmentIssues = order.issues.edges.filter((issue) => { var _a; return ((_a = issue.node.shipment) === null || _a === void 0 ? void 0 : _a.id) === shipment.id; });
    const latestScanEvent = (0, react_1.useMemo)(() => {
        let sortedEvents = [];
        if (shipment.scanEvents && shipment.scanEvents.length > 0) {
            sortedEvents = [...shipment.scanEvents];
            sortedEvents.sort(function (a, b) {
                return (0, moment_1.default)(b.scannedAt).diff((0, moment_1.default)(a.scannedAt));
            });
            return sortedEvents[0];
        }
        return null;
    }, [shipment.scanEvents]);
    return (react_1.default.createElement(polaris_1.LegacyCard, { sectioned: true },
        shipment.carrierUrl ? (react_1.default.createElement(polaris_1.InlineStack, { blockAlign: 'center', gap: '0' },
            react_1.default.createElement(polaris_1.Link, { external: true, url: shipment.carrierUrl }, shipment.trackingCode),
            react_1.default.createElement(styles_1.StyledIconContainer, null,
                react_1.default.createElement(polaris_1.Icon, { source: polaris_icons_1.ExternalSmallIcon, tone: 'interactive' })))) : (react_1.default.createElement(polaris_1.Text, { as: 'p' }, shipment.trackingCode)),
        react_1.default.createElement(polaris_1.BlockStack, { gap: '400' },
            react_1.default.createElement("div", { style: { marginTop: '1rem' } },
                react_1.default.createElement(polaris_1.InlineStack, { gap: '100' },
                    react_1.default.createElement(polaris_1.Text, { as: 'p', tone: 'subdued' }, shipment.carrierName),
                    react_1.default.createElement(polaris_1.Badge, null, statusString || 'Unknown'))),
            shipment.estimatedDeliveryDate && (react_1.default.createElement(polaris_1.BlockStack, { gap: '400' },
                react_1.default.createElement(polaris_1.Text, { as: 'h2', variant: 'headingMd' },
                    shipment.status === 'delivered' && 'ORIGINAL ',
                    "ESTIMATED DELIVERY"),
                react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' }, (0, moment_1.default)(shipment.estimatedDeliveryDate).format('MMMM DD, YYYY')))),
            react_1.default.createElement(polaris_1.InlineStack, { align: 'space-between', blockAlign: 'baseline' },
                react_1.default.createElement(polaris_1.Text, { as: 'h2', variant: 'headingMd' }, "LATEST ACTIVITY"),
                shipment.scanEvents && shipment.scanEvents.length > 0 && (react_1.default.createElement(polaris_1.Button, { onClick: callback, variant: 'plain' }, "Shipment History"))),
            latestScanEvent ? (react_1.default.createElement(ScanEventInfo_1.ScanEventInfo, { scanEvent: latestScanEvent })) : (react_1.default.createElement(polaris_1.Text, { as: 'span' }, "No scan events recorded yet...")),
            shipmentIssues.map((issue) => (react_1.default.createElement(OrderDetails_1.IssueDisplay, { issue: issue.node, key: issue.node.id }))) || null)));
};
const ShipmentCards = (props) => {
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const [scanEvents, setScanEvents] = (0, react_1.useState)([]);
    const handleToggleModal = (0, react_1.useCallback)((shipmentEvents) => {
        setShowModal((current) => !current);
        setScanEvents(shipmentEvents);
    }, []);
    if (props.order.shipments.length === 0) {
        return (react_1.default.createElement(polaris_1.LegacyCard, null,
            react_1.default.createElement(polaris_1.EmptyState, { heading: 'No Shipments For This Order Yet', image: noShipments_png_1.default },
                react_1.default.createElement("p", null, "You can view shipment details here once the order is fulfilled and a shipping label has been created."))));
    }
    const sortedShipments = [...props.order.shipments];
    sortedShipments.sort(function (a, b) {
        return (0, moment_1.default)(a.insertedAt).diff((0, moment_1.default)(b.insertedAt));
    });
    return (react_1.default.createElement(styles_2.StyledShipmentsContainer, null,
        sortedShipments.map((shipment, index) => (react_1.default.createElement(ShipmentDisplay, { callback: () => handleToggleModal(shipment.scanEvents || []), index: index, key: shipment.id, order: props.order, shipment: shipment }))) || null,
        react_1.default.createElement(ScanEventModal_1.ScanEventModal, { handleToggleModal: () => handleToggleModal([]), scanEvents: scanEvents, showModal: showModal })));
};
exports.default = ShipmentCards;
